import * as o2Api from "../api";

export const getBbsBulletin = async (params) => {
  try {
    const { data: result } = await o2Api.getBbsBulletin(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    }
    else {
      return [];
    }
  } catch (e) {
    console.error(e.message);
    return [];
  }
};

export const getPosUserList = async (params) => {
  try {
    const { data: result } = await o2Api.getPosUserList(params);
    const { responseBody, responseCode, responseMessage } = result;
    if (responseCode === "200") {
      // 성공
      return responseBody;
    }
    else {
      return [];
    }
  }
  catch (e) {
    console.error(e.message);
    return [];
  }
}
